var exports = {
  "kL": "x04b3a21e--745839--container",
  "K2": "x04b3a21e--745839--logo-container",
  "wm": "x04b3a21e--745839--logo",
};

module.exports = exports;
